import { render, staticRenderFns } from "./serviciosAdicionales.vue?vue&type=template&id=c19fa904"
import script from "./serviciosAdicionales.vue?vue&type=script&lang=js"
export * from "./serviciosAdicionales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports